import { CORP_CLAIMS, CORP_SIGN_UP_TYPE } from './AuthProvider';

/**
 * Returns a simplified role representation for reporting purposes.
 * This function is not the source of truth for authorization logic.
 * Use claims or boolean flags (isInternalAdminUser, isFinancialAdminUser, etc.) for authorization.
 */
export function getReportingRole(
  isInternalAdminUser: boolean,
  isFinancialAdminUser: boolean,
  isParentAdminUser: boolean,
  signUpType: string
): CORP_CLAIMS {
  if (isInternalAdminUser) {
    return CORP_CLAIMS.INTERNAL_ADMIN;
  }

  if (signUpType === CORP_SIGN_UP_TYPE.BASIC) {
    return CORP_CLAIMS.CORP_FINANCIAL_ADMIN;
  }

  if (isFinancialAdminUser) {
    return CORP_CLAIMS.CORP_FINANCIAL_ADMIN;
  }

  if (isParentAdminUser) {
    return CORP_CLAIMS.CORP_PARENT_ADMIN;
  }

  return CORP_CLAIMS.CORP_ADMIN;
}
